// helix-exception: Helix has no semantic token for these hues (Figma needs-input orange, highlight yellow/amber, categorical teal/cyan); primitive ramps with the identical colour are used (F-11)
import { InfoCircle } from 'flowbite-react-icons/outline'

/**
 * Informational banner shown when a report's guidance classification is
 * inconclusive (`uncertain` / `inconclusive`). It surfaces the API's
 * `classificationExplanation` so the provider understands why the result is not
 * a conclusive diagnostic finding. Rendered on the guidance page alongside (or
 * in place of) finalized guidance.
 */
export function InconclusiveGuidanceBanner({ explanation }: { explanation: string }) {
  return (
    <div
      className="flex w-full gap-4 rounded-base border border-orange-300 dark:border-orange-700 bg-warning-50 dark:bg-gray-900 p-4"
      role="status"
      aria-live="polite"
    >
      <InfoCircle className="mt-0.5 h-5 w-5 shrink-0 text-orange-700 dark:text-orange-200" />
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <p className="text-sm font-semibold uppercase leading-5 tracking-tight text-orange-700 dark:text-orange-200">
          Inconclusive
        </p>
        <p className="whitespace-normal break-words text-sm font-normal leading-5 text-orange-700 dark:text-orange-200">
          {explanation}
        </p>
      </div>
    </div>
  )
}

export default InconclusiveGuidanceBanner
